import { render, staticRenderFns } from "./FieldDetail.vue?vue&type=template&id=297bf4c5&scoped=true&"
import script from "./FieldDetail.vue?vue&type=script&lang=js&"
export * from "./FieldDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297bf4c5",
  null
  
)

export default component.exports